<template>
  <VView class="home">
    <div class="home__cta">
      <VText center big>
        <span>WEŹ UDZIAŁ W KONKURSIE I WYGRAJ<br />
        KOLACJĘ Z</span> NATALIĄ KUKULSKĄ!
      </VText>
    </div>

    <VButtonGroup class="home__buttons">
      <VButton alternative to="/menu">Zaczynajmy!</VButton>
    </VButtonGroup>
  </VView>
</template>

<script>
import VView from '@/components/VView.vue';
import VButton from '@/components/VButton.vue';
import VButtonGroup from '@/components/VButtonGroup.vue';
import VMedia from '@/components/VMedia.vue';
import VText from '@/components/VText.vue';

export default {
  name: 'Home',
  components: {
    VView,
    VButton,
    VButtonGroup,
    VMedia,
    VText,
  },
};
</script>

<style lang="scss" scoped>
.home {
  background-image: url('~@/assets/home-artwork.png');
  background-position: bottom center;
  background-size: 100% auto;
  background-repeat: no-repeat;

  @media screen and (max-width: 550px) {
    background-size: auto 80%;
  }

  ::v-deep .view__content {
    padding-top: 68%;
  }

  &__buttons {
    margin-top: -2% !important;
  }

  &__cta {
    max-width: 750px;
    margin: 0 auto;
    padding: 45px;

    box-shadow: 0.5px 4px 19.3px 3.7px rgba(0, 0, 0, 0.6);
    background-color: #65b0e0;

    transform: rotateZ(-1deg);

    ::v-deep .text {
      transform: rotateZ(1deg);
    }
  }
}
</style>
